<template>
  <container>
    <template v-slot:right>
      <div class="login__form container">
        <b-row no-gutters class="w-100">
          <b-col class="text-center">
            <router-link :to="{ name: 'home' }">
              <b-img
                :src="require('@/assets/images/logo-title-b.svg')"
                class="login__form__logo"
                fluid
              />
            </router-link>

            <b-navbar-nav class="login__form__nav justify-content-center">
              <b-nav-item class="active"
                >Sign in<span class="dots"></span
              ></b-nav-item>
              <b-nav-item :to="{ name: 'auth.register-page' }"
                >Register<span class="dots"></span
              ></b-nav-item>
            </b-navbar-nav>

            <login-form> </login-form>
          </b-col>
        </b-row>
      </div>
    </template>
  </container>
</template>
<script>
/**
 * ==================================================================================
 * Login page
 * ==================================================================================
 **/

import SplitLayout from '@/layouts/SplitLayout'
import LoginForm from '@/components/forms/LoginForm.vue'

export default {
  metaInfo: function() {
    return {
      title: 'Login'
    }
  },
  components: {
    container: SplitLayout,
    LoginForm
  }
}
</script>
